import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { CarrinhoProvider } from '../../providers/carrinho/carrinho';
import { ViewProvider } from '../../providers/view/view';
import { SemovelProvider } from '../../providers/semovel/semovel';
import { PedidoListPage } from '../pedido-list/pedido-list';
import { EnderecoListPage } from '../endereco-list/endereco-list';


@Component({
  selector: 'page-pagamento-pedido-form',
  templateUrl: 'pagamento-pedido-form.html',
})
export class PagamentoPedidoFormPage {

  formaPagamento;
  
  observacao:string;
  
  formasPagamento:Array<any>;
  tiposEntrega:Array<any> = [];
  
  troco:number;
  
  endereco:any;
  tipoEntrega:any;

  valorEntrega;
  entregaGratis;

  constructor(public navCtrl: NavController, public navParams: NavParams, private view:ViewProvider, 
    private server:SemovelProvider, public carrinho:CarrinhoProvider, private modalCtrl:ModalController) {

    this.troco = 0;

    this.formasPagamento = [];

    this.carregarDados();
  }

  async carregarDados(){
    try{
      this.formasPagamento = await this.server.postData({method:"forma-pagamento/list"}).toPromise();
      this.tiposEntrega = await this.server.postData({method:"tipo-entrega/list"}).toPromise();
    }catch(error){
      console.error(error);
    }
  }

  ngOnInit(){
    this.calcularEntrega();
  }

  tipoEntregaChanged(evento){
    this.calcularEntrega();
  }

  async calcularEntrega(){
    if(!this.tipoEntrega || (this.tipoEntrega.exigeEndereco && !this.endereco)){
      this.valorEntrega = -1;
      return;
    }

    try{
      const body = {valorTotal:this.carrinho.total, endereco:this.endereco, tipoEntrega:this.tipoEntrega};

      const dados = await this.server.postData({method:"pedido/calcularEntrega"}, body).toPromise();
      const {enregaGratis, valorEntrega} = dados;
      
      this.entregaGratis = enregaGratis;
      this.valorEntrega = valorEntrega;
      
      this.carrinho.setValorEntrega(parseFloat(valorEntrega));
    }catch(err){
      console.error(err);
    }
  }

  validar(){
    if(!this.tipoEntrega){
      this.view.showMessage("É necessário informar o tipo de entrega.");
      return false;
    }else if(this.tipoEntrega.exigirEndereco && !this.endereco){
      this.view.showMessage("É necessário informar o endereço.");
      return false;
    }

    if(!this.formaPagamento){
      this.view.showMessage("É necessário selecionar a forma de pagamento.");
      return false;
    }else if(this.formaPagamento.solicitaTroco && this.troco < 0){
      this.view.showMessage("É necessário informar se precisa de troco.");
      return false;
    }

    return true;
  }

  carregarPedido(){
    const pedido = this.carrinho.carregar_pedido();
    pedido.observacao = this.observacao;
    pedido.formaPagamento = this.formaPagamento;
    pedido.troco = this.troco;
    pedido.enderecoEntrega =  this.endereco ? Object.assign({}, this.endereco, {id:null}) : null;
    pedido.tipoEntrega = this.tipoEntrega;
    return pedido;
  }

  async confirmarPedido(event){
    if(!this.validar()) return;

    const pedido = this.carregarPedido();

    try{
      const sucesso = await this.server.postData({method:"pedido/save"}, pedido).toPromise();

      this.view.showMessage(sucesso.mensagem);
      this.carrinho.limpar_pedido();
      this.navCtrl.setRoot(PedidoListPage);

    }catch(error){
      this.view.showMessage(error);
    }
  }


  selecionarEndereco(){
    console.log('Selecionar endereço')
    const enderecoListModal = this.modalCtrl.create(EnderecoListPage, { modal: true });
    enderecoListModal.onDidDismiss(data => {
      console.log(data);
      const {endereco} = data;
      this.endereco = endereco;
      this.calcularEntrega();
    });
    enderecoListModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/pagamento-pedido-form/pagamento-pedido-form.ts